/* global createjs */

(function($g, createjs, M) {

    var Shape = createjs.Shape;
    var Container = createjs.Container;
    var Tween = createjs.Tween;

    function Introduction(stage, img, duration, text, hommage, fadeDuration) {
        var me = this;
        var data = {
          "texteDebut" : text.intro,
          "nom" : hommage.firstName||"",
          "nomprenom" : hommage.firstName + " " + hommage.lastName,
          "date" : (hommage.born&&hommage.died) ? (hommage.born.year + " / " + hommage.died.year) : ""
        };
        var timeline;
        var intro = new Container();

        // IMAGE DE BACKGROUND
        var background = new createjs.Bitmap(img);
        //background.alpha = 0;
        intro.addChild(background);

        var elmSubIntro = new Container();

        var elmTexteDebut = new createjs.Text(data.texteDebut.toUpperCase(), "70px avenir-light", "#000000");
        elmTexteDebut.x = 0;
        elmTexteDebut.y = 0;
        elmTexteDebut.textBaseline = "alphabetic";
        //elmTexteDebut.alpha = 1;
        elmTexteDebut.textAlign = "center";
        elmSubIntro.addChild(elmTexteDebut);

        var elmNom = new createjs.Text(data.nomprenom.toUpperCase(), "200px avenir-light", "#000000");
        elmNom.x = 0;
        elmNom.y = 200;
        elmNom.textBaseline = "alphabetic";
        //elmNom.alpha = 1;
        elmNom.textAlign = "center";
        elmSubIntro.addChild(elmNom);

        var elmDate = new createjs.Text(data.date, "70px avenir-light", "#000000");
        elmDate.x = 0;
        elmDate.y = 400;
        elmDate.textBaseline = "alphabetic";
        //elmDate.alpha = 1;
        elmDate.textAlign = "center";
        elmSubIntro.addChild(elmDate);

        //elmSubIntro.alpha = 0;
        intro.addChild(elmSubIntro);

        // Drawable zone
        var table = new Shape();
        intro.addChild(table);

        function appear(parent) {
            parent.addChild(intro);
            updateSize();
        }
        function clear() {
            var p = intro.parent;
            if (p) {
                p.removeChild(intro);
            }
        }
        function updateSize() {
            change();
        }

        function change() {
            var pos = timeline.position||0;
            var ww = stage.canvas.width;
            var hh = stage.canvas.height;
            var b = background.getBounds();
            var iwidth = b.width;
            var iheight = b.height;
            var wr = ww / iwidth;
            var hr = hh / iheight;
            var r = M.max(wr, hr);
            var cx = ww*0.5;
            var cy = hh*0.5;
            var p = (pos/duration);

            var scaler = r + 0.8 - p*0.5;
            var w = iwidth*scaler;
            var h = iheight*scaler;

            // ON CREER UN MOUVEMENT SUR LE BACKGROUND.
            //background.alpha = 1;
            background.scaleX = scaler;
            background.scaleY = scaler;
            background.x = cx - w/2;
            background.y = cy - h/2;

            // ON CACHE L'INTRODUCTION QUAND LES IMAGES S'AFFICHENT.

            /*var div = 0.1;
            if (p > 1) {                        
                intro.alpha = Math.max( ((((1+div) - p)/div)) , 0 ); 
            } else { intro.alpha = 1; }*/

            // ON GÈRE L'AFFICHAGE DE INTRO

            var nameb = elmSubIntro.getBounds();
            var bh = nameb.height;
            var bw = nameb.width;
            var wr = ww / bw;
            var hr = hh / bh;
            var trans = 2-(p*2);
            if (trans < 1){ trans = 1; }
            var rn = M.min(wr, hr)*0.5*trans;

            //elmSubIntro.alpha = Math.max( ((((1+div) - p)/div)) , 0 );
            elmSubIntro.scaleX = rn;
            elmSubIntro.scaleY = rn;
            elmSubIntro.x = cx;
            elmSubIntro.y = cy - 50;
        };

        this.show = appear;
        this.hide = clear;
        this.resize = updateSize;
        this.ready = true;

        var init = function() {
            timeline = Tween.get(intro, {paused: true, onChange: change});
            timeline
                    .wait(duration);
            me.timeline = timeline;
        };

        init();
    }

    $g.Introduction = Introduction;

})(PVPGEngine, createjs, Math);
